import React from 'react';
import propTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styles from './oauth-request.scss';

class OauthRequest extends React.Component {
  static propTypes = {
    user_name: propTypes.string.isRequired,
    _csrf_token: propTypes.string.isRequired,
    cached_params_token: propTypes.string.isRequired,
    instance_url: propTypes.string.isRequired,
  };

  render() {
    return (
      <div id="site-wrapper">
        <div id="site-canvas">
          <div className="l-app--container l-padding-t-60">
            <div className="l-app--content center">
              <div className="row">
                <h2 className="headline">
                  <FormattedMessage
                    id=""
                    defaultMessage="Hello, {userName}"
                    description="Greeting on the Salesforce authorization page"
                    values={{ userName: this.props.user_name }}
                  />
                </h2>
                <h1 className="headline">
                  <FormattedMessage
                    id=""
                    defaultMessage="Granting access to Salesforce"
                    description="Heading on the Salesforce authorization page"
                  />
                </h1>
                <h2>
                  <FormattedMessage
                    id=""
                    defaultMessage="Org: {instanceUrl}"
                    description="Salesforce organization on the authorization page"
                    values={{ instanceUrl: this.props.instance_url }}
                  />
                </h2>
              </div>

              <div className={styles['mt-5']}>
                <p>
                  <FormattedMessage
                    id=""
                    defaultMessage="Salesforce will have access to:"
                    description="Introduction to the Salesforce authorization permissions list"
                  />
                </p>
                <ul className={styles['mt-3']} style={{ marginTop: '1rem' }}>
                  <li>
                    <FormattedMessage
                      id=""
                      defaultMessage="Your basic information"
                      description="Basic information permission on the Salesforce authorization page"
                    />
                  </li>
                  <li>
                    <FormattedMessage
                      id=""
                      defaultMessage="Documents"
                      description="Documents permission on the Salesforce authorization page"
                    />
                  </li>
                  <li>
                    <FormattedMessage
                      id=""
                      defaultMessage="Templates"
                      description="Templates permission on the Salesforce authorization page"
                    />
                  </li>
                  <li>
                    <FormattedMessage
                      id=""
                      defaultMessage="Sending signature requests"
                      description="Signature request permission on the Salesforce authorization page"
                    />
                  </li>
                </ul>
              </div>

              <div className={styles['mt-5']}>
                <form
                  className={styles.inline}
                  method="get"
                  action="/salesforce/SalesforceOAuthCallback"
                >
                  <input type="hidden" name="confirm" value="1" />
                  <input
                    type="hidden"
                    name="_csrf_token"
                    value={this.props._csrf_token}
                  />
                  <input
                    type="hidden"
                    name="cached_params_token"
                    value={this.props.cached_params_token}
                  />
                  <button
                    type="submit"
                    className="m-button bg-cerulean c-white"
                  >
                    <FormattedMessage
                      id=""
                      defaultMessage="Grant"
                      description="Button to approve Salesforce authorization"
                    />
                  </button>
                </form>
                <a href="/home/index" className="m-button bg-red c-white">
                  <FormattedMessage
                    id=""
                    defaultMessage="Cancel"
                    description="Button to cancel Salesforce authorization"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default OauthRequest;
